import React, { Fragment, useEffect } from "react";
import Router from "./routers/router";
import { useDispatch, useSelector } from "react-redux";
import { clearError, clearNotification } from "./redux/notificationReducer";
import { ToastContainer } from "react-toastify";
import { useGetProfileQuery } from "./services/admin/admin.rtk.api";
import { ThemeProvider } from "./contexts/ThemeContext";
import { getToken } from "./utils/auth";

const App: React.FC = () => {
  const { error, notifications } = useSelector(
    (state: any) => state.notification
  );
  const dispatch = useDispatch();

  // Check if token exists before calling profile API
  const token = getToken();
  const { data: profileResp } = useGetProfileQuery(undefined, {
    skip: !token,
  });

  // Handle different possible data structures
  const profile = profileResp?.result ?? profileResp;

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        dispatch(clearError());
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error, dispatch]);

  useEffect(() => {
    if (notifications.length > 0) {
      const timer = setTimeout(() => {
        notifications.forEach((notification: any) => {
          if (!notification.read) {
            dispatch(clearNotification(notification.id));
          }
        });
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [notifications, dispatch]);

  return (
    <ThemeProvider>
      <ToastContainer />
      <Router />
    </ThemeProvider>
  );
};

export default App;
